import React, { useEffect, useState } from "react";
import { Card, Col, Dropdown, Form, Image, Row, Spinner, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import IMAGES from "constants/images";
import { Link, useNavigate } from "react-router-dom";
import { getNotificationList } from "api/ActivityService";
import { getMyProfileDetails, updateProfile } from "api/authService";
import { Sentry } from "react-activity";
import Loader from "components/Loader";
const NotificationCard = ({ title, message, actionText, createdAt,type }) =>{ 
  const getIcon = (type) => {
    if(type==='reviews' || type==='comments'){
      return IMAGES.Reviews_IMG;
    }
    if(type==='disputes'){
      return IMAGES.Notifications_IMG;
    }
    if(type==='badges'){
      return IMAGES.Badge_IMG;
    }
    if(type==='follow'){
      return IMAGES.Followers_IMG;
    }
    if(type==='verified' || type==='password'){
      return IMAGES.Approved_IMG;
    }
    if(type==='welcome'){
      return IMAGES.Welcome_IMG;
    }
    return IMAGES.Notifications_IMG;
  }

  return  (
  <Card className="mb-3 notification-card">
    <Card.Body>
      <Row className="align-items-start">
        <Col className="d-flex">
          <Image
            className="notification_icon me-3 flex-shrink-0"
            src={getIcon(type)}
            alt=""
          />

          <div className="d-flex justify-content-between flex-wrap " style={{ width: '100%' }}>
            <Card.Title className="d-flex justify-content-between " style={{ width: '100%' }}>{title}

              <small className="text-muted">{new Date(createdAt).toLocaleDateString()}</small>

            </Card.Title>
            <Card.Text className="text-muted mb-1">
              {message}{" "}
              {/* {actionText && (
                <Link className="text-primary fw-semibold" to="#">
                  {actionText}
                </Link>
              )} */}
            </Card.Text>
          </div>


        </Col>

      </Row>


    </Card.Body>
  </Card>
)};

const SortDropdown = ({ preferences, handleToggle }) => (
  <Dropdown className="sortDropdown sortDropdownNotification" align="end">
    <Dropdown.Toggle variant="light">
      <Icon icon="solar:settings-outline" fontSize={20} className="me-2" />
      Settings
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {[
        { label: "Reviews", key: "isReviewsNotification" },
        { label: "Comments", key: "isCommentsNotification" },
        { label: "Badges", key: "isBadgesNotification" },
        { label: "Followers", key: "isFollowersNotification" },
      ].map(({ label, key }) => (
        <div key={key} className="d-flex align-items-center justify-content-between mb-2">
          {label} Notifications
          <Form.Check
            type="switch"
            id={key}
            checked={preferences[key] === "active"}
            onChange={() => handleToggle(key)}
          />
        </div>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

const NotificationsTab = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [preferences, setPreferences] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const fetchNotifications = async (pg = 1) => {
    setLoading(true);
    try {
      const res = await getNotificationList(pg, 4);
      if (res.success) {
        setNotifications(pg === 1 ? res.body.data : [...notifications, ...res.body.data]);
        setTotalPages(res.body.total_pages);
      }
    } finally {
      setLoading(false);
      setPageLoading(false)
    }
  };

  const fetchPreferences = async () => {
    const res = await getMyProfileDetails();
    if (res.success) {
      setPreferences({
        isReviewsNotification: res.body.isReviewsNotification,
        isCommentsNotification: res.body.isCommentsNotification,
        isBadgesNotification: res.body.isBadgesNotification,
        isFollowersNotification: res.body.isFollowersNotification,
      });
    }
  };

  const handleToggle = async (key) => {
    const updatedValue = preferences[key] === "active" ? "inactive" : "active";
    const payload = { [key]: updatedValue };
    const res = await updateProfile(payload);
    if (res.success) {
      setPreferences((prev) => ({ ...prev, [key]: updatedValue }));
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchPreferences();
  }, []);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchNotifications(nextPage);
  };

  return pageLoading ? (
    <div className="loaderdiv">
      <Sentry color="#e91515" size={40} speed={1} animating={true} />
      {/* <Loader  style={{width: 100, height: 100}} /> */}
    </div>
  ) : (
    <>
      <div className="tab_1_style">
        <div className="software_header right_profile_style1 rowResponsive mb-3 header_profile3">
          <h2>Notifications</h2>
          <div className="lefAutoPro">
            {/* <Link className="fw-normal me-3">Mark All Read</Link> */}
            <SortDropdown preferences={preferences} handleToggle={handleToggle} />
          </div>
        </div>
        <div className="profile_details_style  header_profile2  d-flex  justify-content-between ">
              <div className="d-flex align-items-center">
                <Icon
                  icon="mdi:arrow-left"
                  style={{ fontSize: "24px" }}
                  className="me-4"
                  onClick={() => navigate("/my-profile")}
                />
                <h2 className="mb-0">Notifications</h2>
           
              </div>
              <div className="lefAutoPro">
            {/* <Link className="fw-normal me-3">Mark All Read</Link> */}
            <SortDropdown preferences={preferences} handleToggle={handleToggle} />
          </div>
            </div>

  

        {notifications.length === 0 && !loading && (
           <Col xs={12}>
           <div className="text-center py-5">
             <Image
               src={IMAGES.emptyState}
               alt=""
                  height="300px"
               width= "300px"
               className="mb-4"
               // className="imgUser"
             />
          <div className="text-center py-5 text-muted">No notifications found.</div>
          </div>
          </Col>
        )}

        {notifications.map((notif) => (
          <NotificationCard key={notif._id} {...notif} actionText={notif.type==='reviews' ? 'Check Now!' : ''} linkUrl={notif.type==='reviews' ? `/vendor/reviews/${notif.reviewId}` : '#'} />
        ))}

        {page < totalPages && (
          <div className="text-center mt-4">
            <Button onClick={handleLoadMore} disabled={loading} variant="link">
              {loading ? <Spinner animation="border" size="sm" /> : "Load More"}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationsTab;
